import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;
axios.interceptors.response.use(res => {
  return res.data;
});

export const postRedPacketRecharge = (data) => {
    return axios.post('/kzweixin/v1/redPacket/rechargeV2',data, {
      baseURL: ''
    })
}

export const getIsRedPacketVip = () => {
  return axios({
    baseURL: '',
    method: 'GET',
    url: '/kzweixin/v1/redPacket/isRedPacketVIP',
  })
}

export const getCalcPrice = (rechargePrice) => {
  return axios({
    baseURL: '',
    method: 'GET',
    url: `/kzweixin/v1/redPacket/calcPrice?rechargePrice=${rechargePrice}`,
  })
}